import Pair from '../models/Pair'
const state = {
  pairs: [],
}

const mutations = {
  'SET_PAIRS'(state, pairs) {
    state.pairs = pairs
  },
}

const actions = {
  async set_pairs({commit}) {
    try {
      let pairs = await Pair.all(`sort=symbol%7Casc&page=1&per_page=999&filter=`)
      commit('SET_PAIRS', pairs.data)
      return pairs.data
    } catch (e) {
      return e
    }
  },
}

const getters = {
  pairs: state => {
    return state.pairs
  },
}

export default {
  state,
  mutations,
  actions,
  getters
}
